import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

export default async (to, from, next) => {
  const uid = firebase.auth().currentUser.uid;

  let paymentMethods = await firebase
    .firestore()
    .collection("users")
    .doc(uid)
    .collection("stripeCards")
    .get();
  if (paymentMethods.size) {
    return next();
  }

  return next({ name: "App: Order Add Card" });
};
